import axios from "axios";
import { ApiResponse } from "../../../../Data/apiResponse";
import { axiosService, ServiceEndPoint } from "../../../../Services/common/Axios.service";
import { ASN } from "../../model/asnOverview.model";
import ASNValidateResponse, { CallbackSection } from "../Model/AsnRecive.model";
const SERVICE_URL = ServiceEndPoint.inbound_service;
const MOBILE_SERVICE_URL = ServiceEndPoint.mobile_inbound_service;
export const getData = async (apiEndpoint: string): Promise<ApiResponse<any>> => {

    const finalEndPoint = `/apijson/inbound/receive${apiEndpoint}`
    const response: ApiResponse<any> = await axios.get(finalEndPoint);
    return response.data;
}
export async function getAsnDetails(id?: string): Promise<ApiResponse<ASN>> {
    const response = await axiosService.get(`${SERVICE_URL}inbound-shipments/${id}`);
    return response.data;
}
export async function validateASN(payload:any): Promise<ApiResponse<ASNValidateResponse>> {

    const response = await axiosService.post(`${MOBILE_SERVICE_URL}receive/validateasn`,payload);
    return response.data;
}
export async function validateMobileField(callback_url:string,payload:any): Promise<ApiResponse<ASNValidateResponse>> {

    const response = await axiosService.post(`${MOBILE_SERVICE_URL}${callback_url}`,payload);
    return response.data;
}
export async function getDeskTopBottomSection(data:CallbackSection): Promise<ApiResponse<any>> {

    const response = await axiosService.post(`${SERVICE_URL}${data.callback_url}`,data.call_back_url_params);
    return response.data;
}
export const getPayload = (identifier?: string, step?: number, scan_value?: string) => {
    const payload: Record<string, any> = {}; 
  
    if (identifier) payload["identifier"] = identifier;
    if (step) payload["mobile_workflow_step"] = step;
    if (scan_value) payload["scan_value"] = scan_value;
  
    return payload;
  };


